import TemplateView from "../../../TemplateView";

export default class DeleteConfirmationCell extends TemplateView {
    constructor($containerEl, deleteMessageKey, {
        onConfirm = () => {},
        onCancel = () => {}
    }) {
        super($containerEl)
        this.deleteMessageKey = deleteMessageKey
        this.params = {
            onConfirm,
            onCancel
        }
    }

    templateHtml() {
        return "<td class='deleteConfirmationRow' colspan='5'>" +
               "    <div class='messageWrapper'><span class='message'><%=message%></span></div>" +
               "    <div class='confirmBtn'><button><%=confirm%></button></div>" +
               "    <div class='cancelBtn'><%=cancel%></div>" +
               "</td>"
    }

    messageKeys() {
        return {
            message: this.deleteMessageKey,
            confirm: "common.delete_confirm",
            cancel: "common.cancel"
        }
    }

    afterRender() {

        this.find('.confirmBtn').click(this.params.onConfirm);
        this.find('.cancelBtn').click(this.params.onCancel);
    }

    remove() {
        this.$el.remove()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/DeleteConfirmation.js